/* eslint-disable react/require-default-props */
import { BookCard } from "@/components";
import { useDesignMaxTheme } from "@/packages";
import { Center, Grid, Spinner } from "@chakra-ui/react";
import { useCheckFakeValue, useCheckInValue, useCheckOutValue, useReserveSuccessValue } from "@shared/client";
import { useNewData } from "./hooks";

export const ReservationList = () => {
    const checkIn = useCheckInValue();
    const checkOut = useCheckOutValue();
    const checkFake = useCheckFakeValue();
    const { isLaptop, isTablet, isMobile } = useDesignMaxTheme().MEDIAS();

    const { data, isLoading } = useNewData({ checkIn, checkOut, checkFake });
    const isReserveStatus = useReserveSuccessValue();

    if (isLoading || !isReserveStatus) {
        return <Spinner />;
    }

    const lapTopFlexiBleGridNumber = isLaptop ? "3" : "4";
    const flexibleGridNumber = isTablet ? "2" : lapTopFlexiBleGridNumber;
    const gridNumberRepeat = `repeat(${isMobile ? "1" : flexibleGridNumber}, 1fr)`;

    return (
        <Grid
            w="100%"
            justifyContent="flex-start"
            gridTemplateColumns={gridNumberRepeat}
            gap={isLaptop ? "40px 20px" : "40px"}
        >
            {data?.currentRooms.map((currentRoom) => (
                <Center position="relative" key={currentRoom.roomIdx}>
                    <BookCard dayNight={data.dayNights} currentRoom={currentRoom} />
                </Center>
            ))}
        </Grid>
    );
};
